/**
 * Easy cookies handling class
 */
window.Cookies =
{
	/**
	 * GET a cookie
	 * @param    {string}       name  Cookie's name
	 * @returns  {string|null}        Cookie's value, or null if cookie not found
	 */
	get: function (name)
	{
		name += '=';  // String to search
		var parts = document.cookie.split(';');  // Splitting cookies
		for (let i = 0; i < parts.length; ++i)  // Looping them ...
		{
			parts[i] = parts[i].ltrim();  // Left trim
			if (parts[i].indexOf(name) == 0) return parts[i].substring(name.length);  // If match, return value
		}
		return null;  // No cookie, return null
	},

	/**
	 * SET a cookie
	 * @param  {string}  name       Cookie's name
	 * @param  {string}  value      Cookie's value
	 * @param  {number}  [expires]  Optional. Cookie's lifetime in seconds [ default: session duration ]
	 * @param  {object}  [params]   Optional. Cookie's parameters (path, domain, samesite, secure)
	 */
	set: function (name, value, expires, params)
	{
		// Base information
		var cookieString = name + '=' + value;

		// Add expiration
		if (expires)
		{
			var date = new Date();  // new Date object
			date.setTime(date.getTime() + (expires * 1000));  // Calculating expire time
			cookieString += '; Expires=' + date.toGMTString();  // Converting to string
		}

		// Add parameters, if there
		if (params && (typeof params === 'object'))
		{
			if (params.path) cookieString += '; Path=' + params.path;  // Add path
			if (params.domain) cookieString += '; Domain=' + params.domain;  // Add domain
			if (params.samesite) cookieString += '; SameSite=' + params.samesite;  // Add samesite
			if (params.secure) cookieString += '; Secure';  // Add secure
		}

		// Finally, setting cookie
		document.cookie = cookieString;
	},

	/**
	 * DELETE a cookie
	 * @param  {string}  name       Cookie's name
	 * @param  {object}  [params]   Optional. Cookie's parameters (path, domain, samesite, secure)
	 */
	delete: function (name, params)
	{
		this.set(name, '', -1, params);  // Set with negative expire time
	}
}

// ***  Easy cookies handling class - End  *** //
